import geofencing from "./geofencing";

export function getZonesInsidePoint(point, zones) {
    return zones.filter((zone) => geofencing._isInPolygon(point, zone.points) ? zone : null)
}